/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Load Josefin Sans typeface
require("@openfonts/josefin-sans_all");
